import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { Card } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import { asyncWrap } from '../utils/utils';
import axios from 'axios';

const statusColors = {
  Pending: '#faad14',
  Rejected: '#ff4d4f',
  'In Discussion': '#1890ff',
  Approved: '#52c41a',
};

const LeadManagement = () => {
  const [expandedCard, setExpandedCard] = useState(null);
  const [leadDetails, setLeadDetails] = useState([]);
  const history = useHistory();

  const getLead = async () => {
    const [error, result] = await asyncWrap(axios.get('lead'));
    if (!result) {
      console.log(error);
      Swal.fire('Something Went Wrong!');
    }
    setLeadDetails(result.data.data);
  };

  useEffect(() => {
    getLead();
  }, []);

  // Dummy Leads - replace with API response
  const leads = [
    {
      id: 1,
      projectName: 'Skyline Residency',
      ownerContact: '9876543210',
      projectLocation: 'Surat',
      quantity: '1500 Bags',
      productCategory: 'Cement',
      retailerName: 'Shree Traders',
      skuid: 'SKU-123456',
      status: 'pending',
    },
    {
      id: 2,
      projectName: 'Green Villa',
      ownerContact: '9988776655',
      projectLocation: 'Ahmedabad',
      quantity: '900 Bags',
      productCategory: 'Cement',
      retailerName: 'Patel Traders',
      skuid: 'SKU-99887',
      status: 'approve',
    },
  ];

  const toggleExpand = id => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <div style={{ padding: '10px', maxWidth: 480, margin: '0 auto' }}>
      {/* Add Lead Button */}
      <Button
        color='primary'
        block
        style={{
          marginBottom: '15px',
          fontSize: '16px',
          padding: '10px',
          borderRadius: '8px',
        }}
        onClick={() => {
          history.push('/add-lead');
        }}
      >
        + Add New Lead
      </Button>

      {/* Lead List */}
      <div style={{ overflowY: 'auto', maxHeight: '85vh' }}>
        {leadDetails.map(lead => (
          <Card
            key={lead.LeadInquiryID}
            style={{
              marginBottom: '12px',
              borderRadius: '12px',
              border: '1px solid #e8e8e8',
            }}
            bodyStyle={{ padding: '12px' }}
          >
            {/* Top Row: Project Name + Status */}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h4 style={{ margin: 0, fontSize: '16px' }}>
                {lead.SkuUniqueId}
              </h4>

              <span
                style={{
                  background: statusColors[lead.AdminApproveStatus],
                  color: 'white',
                  padding: '2px 10px',
                  borderRadius: '20px',
                  fontSize: '12px',
                }}
              >
                {lead.AdminApproveStatus}
              </span>
            </div>

            {/* Small Preview Info */}
            <p style={{ margin: '6px 0 0 0', fontSize: '14px', color: '#555' }}>
              Qty: {lead.TotalQtyRequirement}
            </p>

            {/* Expand Button */}
            <div
              onClick={() => toggleExpand(lead.LeadInquiryID)}
              style={{
                marginTop: '10px',
                display: 'flex',
                justifyContent: 'flex-end',
                cursor: 'pointer',
                color: '#1890ff',
              }}
            >
              {expandedCard === lead.LeadInquiryID ? (
                <>
                  Hide Details{' '}
                  <UpOutlined style={{ marginLeft: 5, marginTop: 5 }} />
                </>
              ) : (
                <>
                  View Details{' '}
                  <DownOutlined style={{ marginLeft: 5, marginTop: 5 }} />
                </>
              )}
            </div>

            {/* Expanded Details */}
            {expandedCard === lead.LeadInquiryID && (
              <div
                style={{
                  marginTop: '10px',
                  padding: '10px',
                  background: '#fafafa',
                  borderRadius: '8px',
                  fontSize: '14px',
                }}
              >
                {[
                  { label: 'Name Of Project', value: lead.NameOfProject },
                  { label: 'Contact Of Owner', value: lead.ContactofOwner },
                  {
                    label: 'Location Of Project',
                    value: lead.LocationofProject,
                  },
                  {
                    label: 'Total Qty Requirement',
                    value: lead.TotalQtyRequirement,
                  },
                  { label: 'Product Category', value: lead.ProductCategory },
                  {
                    label: 'From Which Retailer You Bought',
                    value: lead.FromWhichRetaileryouBought,
                  },
                  { label: 'SKU ID', value: lead.SkuUniqueId },
                  { label: 'Point', value: lead.Point },
                ].map(item => (
                  <div
                    key={item.label}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '8px',
                    }}
                  >
                    <strong>{item.label}:</strong>
                    <span>{item.value}</span>
                  </div>
                ))}
                <div style={{ marginTop: '10px' }}>
                  {[
                    { label: 'Admin Approval', value: lead.AdminApproveStatus },
                    {
                      label: 'Manager Approval',
                      value: lead.ManagerApproveStatus,
                    },
                    {
                      label: 'Salesman Approval',
                      value: lead.SalesManApproveStatus,
                    },
                  ].map(item => (
                    <div
                      key={item.label}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '10px',
                      }}
                    >
                      <strong>{item.label}:</strong>

                      <span
                        style={{
                          background: statusColors[item.value] || '#d9d9d9',
                          color: 'white',
                          padding: '3px 10px',
                          borderRadius: '12px',
                          fontSize: '12px',
                        }}
                      >
                        {item.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default LeadManagement;
